// src/pages/controleBar/comandas/ComandaItemModal.js
import React, { useState } from "react";
import Input from "../../../components/input/Input";
import "./ComandaItemModal.css";
import { useProduto } from "../../../contexts/produtos/ProdutoContext";
import ModalPortal from '../../../components/modalForm/ModalPortal';

const ComandaItemModal = ({ show, onHide, onConfirm }) => {
  const [produto, setProduto] = useState({ id: "", descricao: "", quantidade: 1 });
  const [itens, setItens] = useState([]);
  const { showProdutoSearch } = useProduto();

  if (!show) return null;

  const handleAddItem = () => {
    if (!produto.id || !produto.descricao) return;

    setItens([...itens, { ...produto, quantidade: parseInt(produto.quantidade) || 1 }]);
    setProduto({ id: "", descricao: "", quantidade: 1 });
  };

  const handleConfirm = () => {
    onConfirm(itens);
    onHide();
  };

  const handleBuscarProduto = async () => {
    const produtoSel = await showProdutoSearch();
    if (produtoSel) {
      setProduto({
        id: produtoSel.id,
        descricao: produtoSel.descricao,
        quantidade: 1,
      });
    }
  };

  const handleIncrement = (idx) => {
    const novosItens = [...itens];
    novosItens[idx].quantidade += 1;
    setItens(novosItens);
  };

  const handleDecrement = (idx) => {
    const novosItens = [...itens];
    if (novosItens[idx].quantidade > 1) {
      novosItens[idx].quantidade -= 1;
      setItens(novosItens);
    }
  };

  return (
    <ModalPortal show={show}>
    <div className="comanda-modal-overlay">
      <div className="comanda-modal">
        <div className="comanda-modal-header">
          <h3>Adicionar Itens à Comanda</h3>
          <button className="close-btn" onClick={onHide}>×</button>
        </div>

        <div className="comanda-modal-body">
          <div className="input-row">
            <Input
              label="Código"
              value={produto.id}
              onChange={(e) => setProduto({ ...produto, id: e.target.value })}
              btnBuscar={() => handleBuscarProduto()}
            />
            <Input
              label="Descrição"
              value={produto.descricao}
              onChange={(e) => setProduto({ ...produto, descricao: e.target.value })}
              size={300}
            />
            <Input
              label="Qtd"
              value={produto.quantidade}
              onChange={(e) =>
                setProduto({ ...produto, quantidade: parseInt(e.target.value) || 1 })
              }
              size={60}
            />
            <button className="btn btn-add" onClick={handleAddItem}>
              Adicionar
            </button>
          </div>

          <table className="itens-grid">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Qtd</th>
              </tr>
            </thead>
            <tbody>
              {itens.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.id}</td>
                  <td>{item.descricao}</td>
                  <td className="qtd-cell">
                    <button className="btn-qty" onClick={() => handleDecrement(idx)}>-</button>
                    <span>{item.quantidade}</span>
                    <button className="btn-qty" onClick={() => handleIncrement(idx)}>+</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="comanda-modal-footer">
          <button className="btn btn-confirm" onClick={handleConfirm}>
            Confirmar
          </button>
          <button className="btn btn-cancel" onClick={onHide}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default ComandaItemModal;
